import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Grid } from 'coreOld/elements';

type InputWrapperProps = { children?: ReactNode };

export const InputWrapper = styled(Grid)<InputWrapperProps>`
  display: flex;
  align-items: center;
`;

type SignProps = { children?: ReactNode; bold?: boolean };

export const Sign = styled.div<SignProps>`
  margin-right: 15px;

  ${({ bold }) =>
    bold &&
    css`
      font-weight: 500;
    `}
`;

type TextProps = { children?: ReactNode; marginRight?: number };

export const Text = styled.div<TextProps>`
  font-weight: 500;

  ${({ marginRight }) =>
    marginRight &&
    css`
      margin-right: ${marginRight}px;
    `}
`;

type FlexProps = { children?: ReactNode; flex?: number };

export const Flex = styled.div<FlexProps>`
  flex: 1;

  ${({ flex }) =>
    flex &&
    css`
      flex: ${flex};
    `}
`;

export const FieldsWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 1em;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.text.secondary}`};
  padding: 20px 30px;
`;

export const ErrorWrapper = styled.div`
  padding: 0px 30px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonWrapper = styled.div`
  align-self: flex-end;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const RemoveBtn = styled.div`
  margin-top: 10px;
`;

export const BottomBtnWrapper = styled.div`
  border-top: ${({ theme }) => `1px solid ${theme.palette.text.secondary}`};
  padding: 5px 30px 10px 30px;
`;

export const BtnWrapper = styled.div`
  width: 100%;
  padding: 10px 30px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
`;

export const List = styled.div`
  background-color: ${({ theme }) => theme.palette.backgrounds.main};
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.text.secondary}`};
  padding: 15px 30px;
`;
